var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.progressWrapperClass},[_vm._t("before"),_vm._v(" "),_c('div',{class:_vm.progressClass,style:(_vm.progressStyle),attrs:{"role":"progressbar","aria-valuenow":_vm.currentPercentage,"aria-valuemin":_vm.min,"aria-valuemax":_vm.max,"aria-label":"Free shipping progress bar"}},[_vm._t("default")],2),_vm._v(" "),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }